import ChangePasswordComponent from 'src/components/features/userInfo/changePassword';

const ChangePasswordPage = () => {
  return <ChangePasswordComponent />;
};

export default ChangePasswordPage;
